import { bindTypesToActions } from '@src/utils/redux_utils';

const types={
    SetFireAvatar: 'FIREBASE_SET_CURRENT_AVATAR',
    setAvatarEvent: 'FIREBASE_SELECT_AVATAR',
    SetDisabledCourses: 'FIREBASE_SET_DISABLED_COURSES',
    SetDisabledLevels: 'FIREBASE_SET_DISABLED_LEVELS',
    SetCourses: 'FIREBASE_SET_COURSES',
    SetLesson: 'FIREBASE_SET_LESSON',
    SetLevel: 'FIREBASE_SET_LEVEL',
    SetOnboard: 'FIREBASE_SET_ONBOARD',
    SetTimer: 'FIREBASE_SET_TIME',
    SetParentConsent: 'FIREBASE_PARENT_CONCENT',
    SetBrowsingMode: 'FIREBASE_BROWSING_MODE',
    SendEventData: 'FIREBASE_EVENT_DATA',
    SendGame: 'FIREBASE_SEND_GAME',
    

    // Saga types:
    GetDisabledCourses: 'FIREBASE_GET_DISABLED_COURSES',
    GetDisabledLevels: 'FIREBASE_GET_DISABLED_LEVELS',
    GetCourses:'FIREBASE_GET_COURSES',
    GetLessons:'FIREBASE_GET_LESSONS',
    GetProfileData:'FIREBASE_GET_PROFILE_DATA'
    
}

const FirebaseActions = bindTypesToActions( types );









export {
    types as FirebaseTypes,
    FirebaseActions
}